import React, { useState, useContext, useEffect } from 'react'
import { Col, Row, Form, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMobileAlt, faTabletAlt, faGlobeAsia, faUserCircle, faWindowMaximize } from '@fortawesome/free-solid-svg-icons'
import { NotifyContext } from '../Library/Notify'
import { LanguageContext } from '../Language/LanguageContext'
import { updateUser, viewUser, addUserRole, removeUserRole } from "../Network/User"
import { useHistory, useParams } from 'react-router-dom'
import { Loading, HeaderTitle } from '../Library'
import { listCompany } from '../Network/Company'
import { listDepartment, addUserToDepartment, removeFromDepartment } from '../Network/Department'
import { listRole } from '../Network/Role'
import MultiSelect from "react-multi-select-component";
import "./SpareManageDeviceDetail.css"
import { setDocumentTitle } from '../AppTitle'
import { RoleContext } from "../Role/RoleContext"
import axios from 'axios'
import { wtc53109 } from '../Network/Config'

function SpareMangeDeviceCreate(props) {
    console.log(props.company);
    const langCx = useContext(LanguageContext);
    const lang = langCx.lang.listspare
    const notifyCx = useContext(NotifyContext);
    const history = useHistory();

    const [isLoading, setLoading] = useState(false);
    const [loadingTitle, setLoadingTitle] = useState("Loading");
    const [listDeviceSystem, setListDeviceSystem] = useState([]);
    const [deviceSystem, setDeviceSystem] = useState("");
    const [deviceName, setDeviceName] = useState("");
    const [devicePrice, setDevicePrice] = useState(0);
    const [deviceQuatity, setDeviceQuatity] = useState(0);
    const [isError, setError] = useState(false);


    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect( async () => {
        const formData = new FormData();
        formData.append('company_id', props.company);
        const responseData = await axios.post(wtc53109+'/spare_part/api/v1/list_repair', formData);
        setListDeviceSystem(responseData.data.data.list)
        setDocumentTitle("Create Device Spare")
    }, [10, props])


    const onSubmit = () =>{
        if(!deviceSystem && !deviceName && !devicePrice && !deviceQuatity ){ 
            notifyCx.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            setError(true);
            return;
        }
        setLoadingTitle(lang.updating)
        setLoading(true);
        updateSecurity(deviceSystem,deviceName,devicePrice,deviceQuatity);
        /*updateUser(
            securityName,
            ()=>{
            },
            (error)=>{
                setLoading(false)
                notifyCx.showNotify("Error", error.message, 2)
            }
        )*/
    }
    
    const updateSecurity = async (systemid, name, qty, price) =>{
        console.log(systemid, name, qty, price)
        const formDataUpdate = new FormData();
        formDataUpdate.append('part_name', name);
        formDataUpdate.append('qty', qty);
        formDataUpdate.append('price', price);
        formDataUpdate.append('company_id', props.company);
        formDataUpdate.append('repair_id', systemid);
        
        const responseData = await axios.post(wtc53109+'/spare_part/api/v1/add_spare', formDataUpdate);
        setLoading(false)
        history.push("/managedevice")
    }

    return (
        <>
        { isLoading ? <Loading title={loadingTitle}/>: null }
        <div id="create-user">
            <HeaderTitle title={lang.create_device} isShowBack backTo="/managedevice"/>
            <Row style={{width: "100%"}}>
                <Col className="content-container" md={10} lg={8} xl={6}>
                    <Form
                    onSubmit={(e)=>{
                        e.preventDefault();
                        onSubmit();
                    }}
                    >
                        <Form.Group>
                            <Form.Label>{lang.device_type}</Form.Label>
                            <Form.Control as="select" value={deviceSystem} onChange={(e)=>setDeviceSystem(e.target.value)}>
                                    <option value={''} key={0}>{lang.select_system}</option>
                                {
                                    listDeviceSystem.map((item, key)=>
                                    <option value={item.id} key={key}>{item.name}</option>)
                                }
                            </Form.Control>
                            <Form.Label>{lang.device_name}</Form.Label>
                            <Form.Control
                            placeholder={lang.device_name}
                            value={deviceName}
                            isInvalid={isError && !deviceName}
                            onChange={(e)=>setDeviceName(e.target.value)}
                            />
                            <Form.Label>{lang.device_price}</Form.Label>
                            <Form.Control
                            placeholder={lang.device_price}
                            value={devicePrice}
                            isInvalid={isError && !devicePrice}
                            onChange={(e)=>setDevicePrice(e.target.value)}
                            />
                            <Form.Label>{lang.device_quatity}</Form.Label>
                            <Form.Control
                            placeholder={lang.device_quatity}
                            value={deviceQuatity}
                            isInvalid={isError && !deviceQuatity}
                            onChange={(e)=>setDeviceQuatity(e.target.value)}
                            />
                        </Form.Group>
                        <hr/>
                        <Form.Group>
                            <Button type="submit" style={{marginTop: 30}}>{'บันทึกรายชื่อใหม่'}</Button>
                        </Form.Group>
                        
                    </Form>
                </Col>
            </Row>
        </div>
        </>
    )
}

function AccessItem(props){
    return(
        <div className="access-item"
        onClick={props.onClick}
        role="button"
        tabIndex="0"
        aria-pressed="false"
        onKeyDown={(e)=>{
            if(e.key === "Enter"){
                props.onClick()
            }
        }}
        style={{
            borderColor: props.isError ? "red": "lightgray",
            color: props.isSelected ? "white" : "black",
            backgroundColor: props.isSelected ? "#0275d8": "white"
        }}
        >
            <div>
                <div className="icon">
                    <FontAwesomeIcon icon={props.icon}/>
                </div>
                <div className="title">{props.title}</div>
            </div>
        </div>
    )
}

function RoleList(){
    return(
        <div>
            <b className="title-role">Role</b>
            <div>
                <div className="role-item">
                    <div>System admin</div>
                    <div className="desc">Description here</div>
                </div>
            </div>
        </div>
    )
}

export default SpareMangeDeviceCreate
